import React, { useContext, useEffect } from "react";
import { Stack } from "@mui/material";
import FieldInputText from "components/FieldInputText";
import { ObjectSchema } from 'yup';
import * as Yup from "yup";
import { FormProvider, useForm, Resolver } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {FormContext} from "./index";
import './style.css';

interface IProps {
    schema: any,
    render: (...methods: any) => any
}
const BaseForm = ({ schema, render }: IProps) => {
  const { defaultValues, saveData, setIsSubmitting, _handleSubmit, currentFields} = useContext<any>(FormContext);
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues
  });
  
  const { handleSubmit, formState, reset } = methods;

  useEffect(() => {
    setIsSubmitting(formState.isSubmitting)
  }, [formState, setIsSubmitting])

  useEffect(() => {
    reset(defaultValues)
  }, [defaultValues])

  const onSubmit = (formData: any) =>{
    const data = currentFields.reduce((data: any, field: string) => ({
        ...data,
        [field]: formData[field]
    }), {});

    saveData(data);
    _handleSubmit();
  }
  
    return (
      <FormProvider {...methods}>
        <form id = "projectForm" onSubmit = {handleSubmit(onSubmit)}>
          <Stack gap={3}>
            {render(methods)}
          </Stack>
        </form>
      </FormProvider>
    );
  }
  
  export default BaseForm;